import { module } from "angular";
import "angular-drag-and-drop-lists";
import { GhDndListItemComponent } from "../dnd-list-item/dnd-list-item.component";
import { GhDndListComponent } from "./dnd-list.component";

const mod = module("ghDndList", ["dndLists"]);
mod.component("ghDndList", GhDndListComponent);
mod.component("ghDndListItem", GhDndListItemComponent);
export default mod.name;
